import { defineTokens } from '@pandacss/dev';

export const zIndexTokens = defineTokens.zIndex({
  share_popover: { value: 99 },

  openInApp: { value: 104 },
  // overlay ads
  overlayAdsContainer: { value: 1000 },
  overlayAds: { value: 1001 },

  // header
  header_bottom_sticky: { value: 2000 }, // for bottom sticky header
  header: { value: 2001 },

  // share / repot series actionsheet
  actionsheet_backgrop: { value: 3000 },
  actionsheet: { value: 3001 },

  // drawer
  drawer_backdrop: { value: 3000 },
  drawer: { value: 3001 },

  // bottom SP navigation
  bottom_navigation: { value: 4000 },

  // modal
  modal_backdrop: { value: 5000 },
  teller_modal: { value: 5001 }, // seems "modal" is a reserved word and it picks 1400 always?
  /// notification
  notification: { value: 5002 },

  god: { value: 2_147_483_647 }, // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
});
